import React, { useContext } from "react";

import MaskService from "../../../../utils/mask/maskService";
import { notify } from "../../../../utils/notify";
import { Grid, Grow, IconButton, Tooltip } from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

import TableDefault from "../../../../components/grid/TableDefault";
import { EmissaoContext } from "../contexts/EmissaoContext";
import { Header, AutorizadosXml } from "../styles/Emissao";
import { useState } from "react";
import ModalEmissaoAutorizadosXml from "./ModalEmissaoAutorizadosXml";
import useEmissaoController from "../controllers/EmissaoController";

const TabEmissaoAutorizadosXml = ({ ...props }) => {
  const { xmlAuthorizedList, setXmlAuthorizedList } =
    useContext(EmissaoContext);

  const { handleConfirmActionItem } = useEmissaoController();

  const [modalXmlAuthorized, setModalXmlAuthorized] = useState(false);
  const [indexSize, setIndexSize] = useState(null);

  const handleEditAndOpenSizes = (indexSize) => {
    setIndexSize(indexSize);
    setModalXmlAuthorized(true);
  };

  const handleOpenModalXmlAuthorized = () => {
    if (xmlAuthorizedList.length >= 10) {
      return notify(
        "É possível vincular apenas 10 documentos autorizados ao XML na nota."
      );
    }

    setIndexSize(null);
    setModalXmlAuthorized(true);
  };

  const columnsTableVolume = [
    {
      label: "Ações",
      format: (value) => {
        return (
          <>
            <Tooltip title="Editar">
              <IconButton
                onClick={() => {
                  handleEditAndOpenSizes(value.index);
                }}
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Deletar">
              <IconButton
                onClick={() => {
                  handleConfirmActionItem(
                    value.index,
                    xmlAuthorizedList,
                    setXmlAuthorizedList
                  );
                }}
              >
                <DeleteOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
      align: "center",
      style: { minWidth: 50 },
    },
    {
      label: "Tipo",
      id: "tipo",
      align: "center",
      style: { minWidth: 50 },
    },
    {
      label: "Documento",
      id: "documento",
      align: "center",
      style: { minWidth: 150 },
      format: (item) =>
        MaskService.toMask(item.tipo.toLowerCase(), item.documento),
    },
  ];

  return (
    <>
      {modalXmlAuthorized && (
        <ModalEmissaoAutorizadosXml
          modalXmlAuthorized={modalXmlAuthorized}
          setModalXmlAuthorized={setModalXmlAuthorized}
          indexSize={indexSize}
        />
      )}
      <AutorizadosXml>
        <Grid container spacing={2}>
          <Grow in={true} {...(true ? { timeout: 800 } : {})}>
            <Grid item sm={12}>
              <TableDefault
                columns={columnsTableVolume}
                values={xmlAuthorizedList}
                maxHeight="330px"
                tableTitle={
                  <Header>
                    <Grid container spacing={2}>
                      <Grid item sm>
                        <Chip
                          label="Tabela de Autorizados XML"
                          bgcolor="secondary"
                        />
                      </Grid>
                      <Grid item>
                        <Btn
                          startIcon={<Icon>add</Icon>}
                          label="Adicionar"
                          onClick={handleOpenModalXmlAuthorized}
                        />
                      </Grid>
                    </Grid>
                  </Header>
                }
              />
            </Grid>
          </Grow>
        </Grid>
      </AutorizadosXml>
    </>
  );
};

export default TabEmissaoAutorizadosXml;
